// In production, we register a service worker to serve assets from local cache.

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] es la dirección IPv6 localhost.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 son consideradas como localhost IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])){3}$/
    )
);

export function register(config) {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    // El constructor de URL está disponible en todos los navegadores que soportan SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Nuestro service worker no funcionará si PUBLIC_URL está en un origen diferente.
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // Esto se ejecuta en localhost. Comprueba si un service worker existe o no.
        checkValidServiceWorker(swUrl, config);

        // Añade una actualización de service worker en localhost.
        navigator.serviceWorker.ready.then(() => {
          console.log(
            "This web app is being served cache-first by a service " +
              "worker. To learn more, visit https://cra.link/PWA"
          );
        });
      } else {
        // No es localhost. Simplemente registra el service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // Nuevo contenido está disponible, y ahora la página se va a recargar
              console.log("New content is available and will be used.");
              localStorage.setItem("show_noti", true);

              // Ejecuta la callback de actualización
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // Todo está precacheado. El contenido se usará para futuras visitas.
              console.log("Content is cached for offline use.");

              // Ejecuta la callback de éxito
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Comprueba si el service worker puede ser encontrado. Si no, recarga la página.
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      // Asegúrate de que el service worker exista, y que sea un archivo JS.
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        // No se encontró el service worker. Probablemente un nuevo build está en funcionamiento.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker encontrado. Procesa normalmente.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
